import React, { useState } from "react";
import { colors } from "../../../../../themes/Colors";
import { BaseButtonsIcon } from "../../../../common-components";

const MenuLayout = ({
  onUserClick,
  onAgentsClick,
  onTaskClick,
  selected,
  onProfileClick,
  customerButton,
  AgentButton,
  buzzButton,
  onBuzzClick,
  adminAccess,
  accountStatus,
  onVehiclesClick,
  onCatalogueClick,
  businessType,
}) => {
  const [shrink, setShrink] = useState(false);
  return (
    <div
      style={{
        height: "100%",
        width: shrink ? 85 : 210,

        transition: "all 0.4s",
        display: "flex",
        flexDirection: "column",
        backgroundColor: shrink ? colors.white : colors.white,
        WebkitBoxShadow: "0px 0px 15px 5px #00000040",
        justifyContent: "flex-start",
        alignItems: "center",
        zIndex: 10,
      }}
    >
      <div onClick={() => setShrink(shrink ? false : true)}>
        <div
          style={{
            color:
              businessType === "business"
                ? shrink
                  ? colors.primaryOrange
                  : colors.primaryOrange
                : shrink
                ? colors.primaryBlue
                : colors.primaryBlue,
            fontSize: shrink ? 22 : 32,
            fontWeight: "bold",
            transition: "all 0.3s",
            marginLeft: shrink ? -5 : 0,
            marginTop: shrink ? 0 : 0,
            transform: shrink ? `rotate(90deg)` : null,
            cursor: "pointer",
            marginBottom: shrink ? 0 : 0,
          }}
        >
          <img
            alt="logo"
            src={
              shrink
                ? businessType === "business"
                  ? require("../../../../../images/base-logo-desgns/driverfriendIconOrange.png")
                  : require("../../../../../images/base-logo-desgns/driverFriendIconBlue.png")
                : businessType === "business"
                ? require("../../../../../images/base-logo-desgns/driverFriendOrangeLogo.png")
                : require("../../../../../images/base-logo-desgns/driverFriendLogoBlue.png")
            }
            style={{ width: shrink ? 100 : "100%" }}
          />
        </div>
      </div>
      <BaseButtonsIcon
        disable={accountStatus ? accountStatus : customerButton ? false : true}
        label={"CUSTOMERS"}
        width={shrink ? "100%" : 150}
        backgroundColor={
          selected === "users"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        borderRadius={8}
        icon2={require("../../../../../images/icons/usersWhite.png")}
        icon={require("../../../../../images/icons/usersWhite.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink ? 18 : shrink}
        shrinkColor={
          selected === "users"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        hoverColor={
          businessType === "business"
            ? colors.orangeDark
            : colors.secondaryDarkBlue
        }
        onClick={onUserClick}
      />
      {adminAccess ? (
        <BaseButtonsIcon
          disable={AgentButton ? false : true}
          label={"AGENTS"}
          width={shrink ? "100%" : 150}
          backgroundColor={
            selected === "agents"
              ? businessType === "business"
                ? colors.orangeDark
                : colors.secondaryDarkBlue
              : businessType === "business"
              ? colors.primaryOrange
              : colors.primaryBlue
          }
          borderRadius={8}
          icon2={require("../../../../../images/icons/profileWhite.png")}
          icon={require("../../../../../images/icons/profileWhite.png")}
          iconHeight={shrink ? 40 : 35}
          iconWidth={shrink ? 40 : 35}
          shrink={shrink ? 18 : shrink}
          shrinkColor={
            selected === "agents"
              ? businessType === "business"
                ? colors.orangeDark
                : colors.secondaryDarkBlue
              : businessType === "business"
              ? colors.primaryOrange
              : colors.primaryBlue
          }
          hoverColor={
            businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
          }
          onClick={onAgentsClick}
          marginTop={15}
        />
      ) : null}

      {businessType === "Agency" ? (
        <BaseButtonsIcon
          // disable={accountStatus ? accountStatus : true}
          label={"TASKS"}
          width={shrink ? "100%" : 150}
          backgroundColor={
            selected === "tasks"
              ? businessType === "business"
                ? colors.orangeDark
                : colors.secondaryDarkBlue
              : businessType === "business"
              ? colors.primaryOrange
              : colors.primaryBlue
          }
          borderRadius={8}
          icon2={require("../../../../../images/icons/shopperWhite.png")}
          icon={require("../../../../../images/icons/shopperWhite.png")}
          iconHeight={shrink ? 40 : 35}
          iconWidth={shrink ? 40 : 35}
          shrink={shrink ? 18 : shrink}
          shrinkColor={
            selected === "tasks"
              ? businessType === "business"
                ? colors.orangeDark
                : colors.secondaryDarkBlue
              : businessType === "business"
              ? colors.primaryOrange
              : colors.primaryBlue
          }
          hoverColor={
            businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
          }
          onClick={onTaskClick}
          marginTop={15}
        />
      ) : null}
      <BaseButtonsIcon
        disable={accountStatus ? accountStatus : buzzButton ? false : true}
        label={"BUZZ"}
        width={shrink ? "100%" : 150}
        backgroundColor={
          selected === "buzz"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        borderRadius={8}
        icon2={require("../../../../../images/material-icon/whiteBee.png")}
        icon={require("../../../../../images/material-icon/whiteBee.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink ? 18 : shrink}
        shrinkColor={
          selected === "buzz"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        hoverColor={
          businessType === "business"
            ? colors.orangeDark
            : colors.secondaryDarkBlue
        }
        onClick={onBuzzClick}
        marginTop={15}
      />
      <BaseButtonsIcon
        label={"PROFILE"}
        width={shrink ? "100%" : 150}
        backgroundColor={
          selected === "profile"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        borderRadius={8}
        icon2={require("../../../../../images/material-icon/whiteMore.png")}
        icon={require("../../../../../images/material-icon/whiteMore.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink ? 18 : shrink}
        shrinkColor={
          selected === "profile"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        hoverColor={
          businessType === "business"
            ? colors.orangeDark
            : colors.secondaryDarkBlue
        }
        onClick={onProfileClick}
        marginTop={15}
      />
      <BaseButtonsIcon
        label={"VEHICLES"}
        width={shrink ? "100%" : 150}
        backgroundColor={
          selected === "vehicles"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        borderRadius={8}
        icon2={require("../../../../../images/material-icon/whiteVehicle.png")}
        icon={require("../../../../../images/material-icon/whiteVehicle.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink ? 18 : shrink}
        shrinkColor={
          selected === "vehicles"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        hoverColor={
          businessType === "business"
            ? colors.orangeDark
            : colors.secondaryDarkBlue
        }
        onClick={onVehiclesClick}
        marginTop={15}
      />
      <BaseButtonsIcon
        label={"CATALOGUE"}
        width={shrink ? "100%" : 150}
        backgroundColor={
          selected === "catalogue"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        borderRadius={8}
        icon2={require("../../../../../images/icons/infoWhite.png")}
        icon={require("../../../../../images/icons/infoWhite.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink ? 18 : shrink}
        shrinkColor={
          selected === "catalogue"
            ? businessType === "business"
              ? colors.orangeDark
              : colors.secondaryDarkBlue
            : businessType === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
        }
        hoverColor={
          businessType === "business"
            ? colors.orangeDark
            : colors.secondaryDarkBlue
        }
        onClick={onCatalogueClick}
        marginTop={15}
      />
    </div>
  );
};

export default MenuLayout;
